import { formatUzLocal, sanitizeUzLocal } from '@posilka/client/lib/phone';

/**
 * `+998` qotirilgan, 9 raqam: `90 123 45 67` ko'rinishida. Qiymat — faqat 9 raqam.
 * Operator kodi faqat O'zbekiston mobil kodlaridan (`sanitizeUzLocal`).
 */
export function PhoneInput({
  value,
  onChange,
  invalid,
}: {
  value: string;
  onChange: (digits: string) => void;
  invalid?: boolean;
}) {
  return (
    <div className="input flex items-center gap-2 py-0" aria-invalid={invalid}>
      <span className="text-hint">+998</span>
      <input
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        className="min-w-0 flex-1 bg-transparent py-3 outline-none"
        placeholder="90 123 45 67"
        value={formatUzLocal(value)}
        onChange={(e) => onChange(sanitizeUzLocal(e.target.value))}
      />
    </div>
  );
}
